<template>
	<div class="pc-square-detail">
		<div class="pc-square-detail__header pc-center-1200">
			<nav :aria-label="t('square.detail.breadcrumb')">
				<Breadcrumb
					class="breadcrumb"
					:name="props.squareInfo?.title"
					back-name="square.breadcrumb"
					back-path="/seer/square"
				/>
			</nav>
		</div>

		<ShortsDetail v-if="isShortsType" :data="props.squareInfo" :square-id="props.squareId" />
		<main v-else class="pc-index pc-center-1200">
			<section class="content" :class="{ 'content--article': isArticleType }">
				<div class="left">
					<Content :data="props.squareInfo" />
				</div>
				<aside class="right">
					<!-- 图文 -->
					<ArticleSidebar
						v-if="isArticleType"
						:square-info="props.squareInfo"
						:square-id="props.squareId"
					/>
					<VideoSidebar v-else :square-info="props.squareInfo" :square-id="props.squareId" />
				</aside>
			</section>
		</main>
	</div>
</template>

<script setup>
import { computed, provide, toRef, watch } from "vue";
import Breadcrumb from "~/components/pc/breadcrumb/index.vue";
import Content from "./components/content/index.vue";
import VideoSidebar from "./components/video-sidebar/index.vue";
import ArticleSidebar from "./components/article-sidebar/index.vue";
import ShortsDetail from "./components/shorts-detail/index.vue";
import { useI18n } from "~/composables/useI18n";
import { useSquareDetailTracking } from "../composables/useSquareDetailTracking";

const { t } = useI18n();

const props = defineProps({
	squareInfo: {
		type: Object,
		default: () => ({}),
	},
	squareId: {
		type: String,
		default: "",
	},
});

const { logDetailEvent, trackDetailPageView } = useSquareDetailTracking(
	"pc",
	toRef(props, "squareInfo")
);
provide("logDetailEvent", logDetailEvent);

const isShortsType = computed(() => Number(props.squareInfo?.video_screen_mode) === 2);
const isArticleType = computed(() => Number(props.squareInfo?.type) === 2);

watch(
	() => props.squareInfo?.id,
	id => {
		if (id) trackDetailPageView();
	},
	{ immediate: true }
);
</script>

<style lang="scss" scoped>
.pc-square-detail {
	&__header {
		margin: 30px auto;

		.breadcrumb {
			padding: 33px 0;
		}

		:deep(.pc-breadcrumb-bar) {
			align-items: center;
		}
	}
}

.pc-index {
	margin-bottom: 150px;

	.content {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 21px;
		width: 1200px;
		border-radius: 20px;
		padding: 30px;
		box-shadow: 0 4px 24.6px 0 rgba(0, 0, 0, 0.1);
		box-sizing: border-box;

		.left {
			flex: 1;
			min-width: 0;
		}

		.right {
			flex: 0 0 539px;
			width: 539px;

			&:not(:has(> *)) {
				display: none;
			}
		}

		&--article {
			.right {
				flex-basis: 442px;
				width: 442px;
			}
		}
	}
}
</style>
